module.exports = __webpack_public_path__ + "img/speed-icon.8fc993e2.svg";